import cn from "classnames";

import { useEnableGcpAccount } from "featureFlags/hooks/useEnableGcpAccount";
import {
  WorkspaceEngine,
  WorkspaceEngineStatus,
} from "services/engines/engine.types";

import EngineIcon from "assets/icons/EngineSelectorIcon.svg?react";

import styles from "../ContextSelector.module.scss";

export const EngineIconWrapper = ({
  engine,
}: {
  engine?: WorkspaceEngine | undefined;
}) => {
  const enabledGcpAccount = useEnableGcpAccount();
  return (
    <EngineIcon
      data-testid="engine-icon-wrapper"
      className={cn(styles.engineIconWrapper, {
        [styles.engineRunning]:
          engine?.status === WorkspaceEngineStatus.RUNNING || enabledGcpAccount,
        [styles.engineStarting]:
          engine?.status === WorkspaceEngineStatus.STARTING,
      })}
    />
  );
};
